import { IPagination } from "../app-configuration";

// @ts-ignore
export interface IHistoryConfigurations<T, TP> {
  pagination?: IPagination;
  slots?: string[]
  allowEdit?: boolean;
  allowDelete?: boolean;
  showInfo?: boolean;
  showPaging?: boolean;
  mode?: string
}
export class HistoryConfigurations<T= any, TP= any> implements IHistoryConfigurations<T, TP> {

  static readonly MODE_TIMELINE: string = 'timeline'
  static readonly MODE_GRID: string = 'Grid'
  static readonly TYPE_ALL: string = 'All';
  static readonly TYPE_PROPERTY_GENERAL: string = 'General'
  static readonly TYPE_PROPERTY_MATCHING: string = 'Matching'
  static readonly TYPE_PROPERTY_PROSPECT: string = 'PropertyProspect'
  static readonly TYPE_PROPERTY_RELATIONS: string = 'Relation'

  static readonly MODULE_PROJECT: string = 'Project'
  static readonly MODULE_PROPERTY_PROPERTY: string = 'Object'
  static readonly MODULE_PROPERTY_PERSON: string = 'Person'
  static readonly MODULE_PROPERTY_DEMAND: string = 'Demand'
  static readonly MODULE_PROPERTY_AGENDA: string = 'Agenda'
  static readonly MODULE_COMPANY: string = 'Company'

  allowEdit?: boolean;
  allowDelete?: boolean;
  showInfo?: boolean;
  showPaging?: boolean;
  mode?: string
  /**
   *
   */
  constructor(option: IHistoryConfigurations<T, TP> = {}) {
    this.allowEdit = option.allowEdit || false
    this.allowDelete = option.allowDelete || false
    this.showInfo = option.showInfo || true
    this.showPaging = option.showPaging || true
    this.mode = option.mode || 'timeline'
  }
}